import { PartialNullable } from "../../Extensions";
import { StringHelper } from "../../Helpers/StringHelper";
import { Property } from "../../RadObject";
import { ElementRef } from "../ElementRef";
import { JsxFragment } from "../JsxFragment";
import { PageManager } from "../PageManager";
import { ContainerControl, ContainerControlPropertyValues, IContainerControl } from "./ContainerControl";
import { NAMESPACE } from "./_Namespace";

export type PageFooterPropertyValues =
    ContainerControlPropertyValues
    & {
    };

export type PageFooterProperties = {
    [name in keyof PageFooterPropertyValues]: Property<PageFooterPropertyValues[name]>
};

export interface IPageFooter extends IContainerControl, PageFooterProperties
{
}

export class PageFooter extends ContainerControl implements IPageFooter
{
    public static override classNamespace = NAMESPACE + "PageFooter";
    public static override className = "PageFooter";

    // #region Global Variables

    protected _containerWrapperElementRef!: ElementRef;

    // #endregion

    // #region Constructor

    constructor(propertyValues?: PartialNullable<PageFooterPropertyValues>)
    {
        super(propertyValues);

        this.addCssClass("rad-control-page-footer");
        this._containerElementRef.current.addClass("ui container fluid");
        this._containerWrapperElementRef.current.addClass("rad-control-container-wrapper");
    }

    // #endregion

    // #region Public Methods

    public addScrollbarPadding()
    {
        this._containerWrapperElementRef.current.css({
            paddingRight: (PageManager.instance?.scrollBarDimensions.get()?.width ?? 0) + "px"
        });
    }
    public removeScrollbarPadding()
    {
        this._containerWrapperElementRef.current.css({
            paddingRight: StringHelper.empty
        });
    }

    // #endregion

    // #region Overrides

    protected override __initializeProperties(propertyValues: PageFooterPropertyValues)
    {
        super.__initializeProperties(propertyValues);

        this._containerWrapperElementRef = new ElementRef();
    }

    protected override _createElementHtml(children?: JsxFragment | string | (JsxFragment | string | undefined)[])
    {
        return (
            <footer class="rad-control rad-control-container-control rad-control-page-footer" >
                <div ref={this._containerWrapperElementRef} class="rad-control-container-wrapper" >
                    <div ref={this._containerElementRef} class="rad-control-container ui container fluid" >
                        {children ?? this._createChildrenHtml()
                        }
                    </div>
                </div>
            </footer>
        );
    }

    // #endregion
}